import { useMutation } from 'react-query';

import { sendMFACode } from '../../lib/api';

export function useMutateSendSmsMfaCode() {
  return useMutation(sendMFACode);
}
